import React, { Component } from 'react'

import i18next from 'i18next'

import invitationStyles from './styles/invitation.scss'
import puzzleIllustration from './../assets/images/wopi-puzzle.png'

export default class Wopi360WhoToInvite extends Component {
  render() {
    return (
      <div className={invitationStyles.wopi360WhoToInvite}>
        <h3>{i18next.t('who_to_invite')}?</h3>

        <p>
          {i18next.t('invite_description_part1')}{' '}
          <strong>{i18next.t('invite_description_part2')}</strong>{' '}
          {i18next.t('invite_description_part3')}:
        </p>

        <ul>
          <li>{i18next.t('invite_description_manager')}</li>
          <li>{i18next.t('invite_description_coworker')}</li>
          <li>{i18next.t('invite_description_employee')}</li>
          <li>{i18next.t('invite_description_other')}</li>
        </ul>

        <p>{i18next.t('invite_feedback_explanation')}</p>

        <p>{i18next.t('invite_description_part4')}.</p>

        <img src={puzzleIllustration} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Wopi360WhoToInvite.js